import { createReducer } from '@reduxjs/toolkit';

import type { DocumentoNotificacaoState } from '../../types/documentoNotificacao.types';
import {
  consultaDocumentoConcluida,
  consultaDocumentoFalhou,
  consultaDocumentoIniciada,
  limparConsultaDocumento,
} from './actions';

const estadoInicial: DocumentoNotificacaoState = {
  numeroNotificacao: null,
  consultaId: null,
  carregando: false,
  erro: null,
};

export const documentoNotificacaoReducer = createReducer(estadoInicial, (builder) => {
  builder
    .addCase(consultaDocumentoIniciada, (_state, { payload }) => ({
      ...estadoInicial,
      ...payload,
      carregando: true,
    }))
    .addCase(consultaDocumentoConcluida, (state, { payload }) => {
      if (state.consultaId !== payload.consultaId) return;
      state.carregando = false;
    })
    .addCase(consultaDocumentoFalhou, (state, { payload }) => {
      if (state.consultaId !== payload.consultaId) return;
      state.erro = payload.erro;
      state.carregando = false;
    })
    .addCase(limparConsultaDocumento, (state, { payload }) =>
      state.numeroNotificacao === payload ? estadoInicial : state,
    );
});
